import DashboardView from '@/views/DashboardView.vue';

const dashboard_routes = {
  path: '/dashboard',
  name: 'dashboard',
  component: DashboardView,
  meta: {
    header: {
      title: 'dashboard.dashboard',
      icon: 'bvi-dashboard',
    },
    breadcrumbs: [
      {
        label: 'dashboard.dashboard',
        route: { name: 'dashboard' },
      },
    ],
  },
};

export default dashboard_routes;
